<template>
  <div id="app">
    <div class="wrapper">
      <div
        class="logo-band"
        v-if="loadStatus && Object.keys(groupOrderDetails).length"
      >
        <div class="redemption-logo">
          <img :src="setLogo" @error="handleBrokenImage" />
        </div>
      </div>
      <Notification />
      <router-view />
    </div>
  </div>
</template>

<script>
import Notification from '../views/Notification'
import { mapState } from 'vuex'
import { progressStatus } from '../helpers'

export default {
  name: 'GroupOrderLayout',
  components: {
    Notification
  },
  data() {
    return {
      gemnoteLogo: require('../assets/gemnote_logo_pebble.png')
    }
  },

  computed: {
    isFinalized() {
      return (
        this.groupOrderDetails &&
        this.groupOrderDetails.state &&
        this.groupOrderDetails.state === 'finalized'
      )
    },

    setLogo() {
      return this.groupOrderDetails && this.groupOrderDetails.teamLogo
        ? this.groupOrderDetails.teamLogo && this.groupOrderDetails.teamLogo.url
        : this.gemnoteLogo
    },
    loadStatus() {
      return progressStatus(this.loadGroupOrderPublicInfo)
    },
    ...mapState({
      loadGroupOrderPublicInfo: state =>
        state.groupOrder.loadGroupOrderPublicInfo,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    })
  },

  watch: {
    loadStatus(newVal) {
      if (newVal) {
        if (this.isFinalized) {
          this.$router.push({
            name: 'notfound',
            params: {
              isFinalized: true
            }
          })
        }
      }
    }
  },

  methods: {
    handleBrokenImage(e) {
      e.target.src = this.gemnoteLogo
    }
  }
}
</script>

<style lang="scss">
@import '@/global.scss';

.logo-band {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6rem;
  background: $main-white;
}

.redemption-logo {
  height: 5.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 9rem;
  img {
    width: inherit;
    height: inherit;
    object-fit: contain;
    padding: 5px;
  }
}
</style>
